export default "__VITE_ASSET__CKWtd_8g__"